import { render, staticRenderFns } from "./En.vue?vue&type=template&id=3196e2d8&scoped=true"
import script from "./En.vue?vue&type=script&lang=js"
export * from "./En.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196e2d8",
  null
  
)

export default component.exports